import axios from "axios";
import Loader from "Components/Loader/loader";
import React from "react";
import { connect } from "react-redux";
import { useFetchGet } from "Services/api";
import GestionDiffuseurCard from "./GestionDiffuseurCard/GestionDiffuseurCard";
import PropTypes from "prop-types";

const GestionDiffuseurs = (props) => {
  let dataDiffuseur = useFetchGet("/diffusers", props.auth.token);
  const onValidation = (id, data) => {
    const url = `${process.env.REACT_APP_BASE_URL_API}/diffusers/${id}`;
    axios
      .put(url, data, {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .then((response) => {
        dataDiffuseur.data = dataDiffuseur.data.map((diffuseur) => {
          if (diffuseur.id !== response.id) {
            return diffuseur;
          } else {
            return response;
          }
        });
      })
      .catch((error) =>
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        })
      );
  };
  return (
    <div className="diffuseur_container">
      {dataDiffuseur.loaded ? (
        dataDiffuseur.data.map((diffuseur, index) => (
          <GestionDiffuseurCard
            key={index}
            diffuseurInfos={diffuseur}
            onValidation={(id, data) => {
              onValidation(id, data);
            }}
          ></GestionDiffuseurCard>
        ))
      ) : (
        <Loader></Loader>
      )}
    </div>
  );
};
GestionDiffuseurs.propTypes = {
  auth: PropTypes.object,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(GestionDiffuseurs);
